// extracted by mini-css-extract-plugin
module.exports = {"timeStatusContainer":"timeStatusIndicator_timeStatusContainer__xL49G","alert":"timeStatusIndicator_alert__Q2iZh"};